import { render, staticRenderFns } from "./ChevronDownIcon.vue?vue&type=template&id=52eca7a6"
import script from "./ChevronDownIcon.vue?vue&type=script&lang=ts"
export * from "./ChevronDownIcon.vue?vue&type=script&lang=ts"
import style0 from "./ChevronDownIcon.vue?vue&type=style&index=0&id=52eca7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports